export enum storageKeys {
  activeSubAccount = "active_sub-account",
}